<template>
  <div class="dialog"
       :style="{height:$store.state.screenHeight+'px'}">
    <div class="login-dialog">
      <p class="login-dialog-title">选择登录账号</p>
      <div class="login-dialog-content">
        <div v-for="(item,index) in items"
             :key="index"
             @click="chooseItem(index)">
          <div class="item-user">
            <img :src="item.headImgIconUrl"
                 class="icon">
            <div class="item-right">
              <p class="nickname">{{filterNickname(item.nickname)}}</p>
              <p class="desc">ID: {{item.uid+10000}}</p>
            </div>
            <img v-if="item.choose"
                 class="choose-tag"
                 src="../assets/music_red_draw_selected.png" />
          </div>
          <div class="line" />
        </div>
      </div>
      <div class="login-dialog-action">
        <input class="dialog-submit"
               type="button"
               value="完成"
               @click="chooseAction">
      </div>
    </div>
    <div class="login-dialog-dismiss">
      <img src="../assets/music_cancel_normal.png"
           @click="dialogDismiss">
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginDialog',
  data () {
    return {
      items: []
    }
  },
  methods: {
    chooseAction: function () {
      var pos = -1;
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].choose) {
          pos = i;
          break;
        }
      }
      if (pos === -1) {
        alert("请选择您要登录的账户");
        return;
      }
      this.$store.commit('setLoginState', this.GLOBAL.LOGIN_STATE_PART2);
    },
    chooseItem: function (index) {
      for (var i = 0; i < this.items.length; i++) {
        if (i == index) {
          this.$set(this.items[i], 'choose', true);
        } else {
          this.$set(this.items[i], 'choose', false);
        }
      }
    },
    dialogDismiss: function () {
      this.$store.commit('setLoginState', this.GLOBAL.LOGIN_STATE_PART0);
    },
    filterNickname: function (name) {
      return name.replace("\n", "").replace("\r", "");
    }
  },
  created () {
    this.items = this.$store.state.loginAccountList;
    if (this.items && this.items.length > 0) {
      this.items[0].choose = true;
    }
  }
}
</script>
<style scoped>
.dialog {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  margin: auto;
}
.login-dialog {
  display: inline-block;
  margin-top: 220px;
  overflow-x: hidden;
  width: 420px;

  background-color: #ffffff;
  border-radius: 10px;
  -moz-border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.login-dialog-content::-webkit-scrollbar {
  width: 6px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道
   内阴影+圆角*/
.login-dialog-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background-color: #f8f8f8;
}
/*定义滑块
   内阴影+圆角*/
.login-dialog-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #e0e0e0;
}
.login-dialog-dismiss img {
  width: 50px;
  margin-top: 20px;
}
.login-dialog-title {
  font-size: 24px;
  font-style: oblique;
  font-weight: 700;
  height: 50px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.line {
  margin-left: 12%;
  margin-right: 12%;
  height: 1px;
  background-color: #e3e3e3;
}
.login-dialog-content {
  height: 317px;
  margin-bottom: 10px;
  overflow-y: auto;
}
.login-dialog-action {
}
.login-dialog-action .dialog-submit {
  display: block;
  width: 360px;
  height: 52.5px;
  background-color: #ff8700;
  background-size: 360px;
  border: 0px;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
  outline: none;
  cursor: pointer;
  margin: auto;
  text-align: center;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
}
.login-dialog-action .dialog-submit:hover {
  opacity: 0.8;
}
.item-user {
  position: relative;
  padding: 14px 5px 14px 5px;
  text-align: left;
  margin-left: 12%;
  margin-right: 12%;
}
.item-user .icon {
  display: inline-block;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  overflow: hidden;
  border: 0px;
}
.item-user .nickname {
  font-family: PingFangSC-Medium;
  color: #302e3c;
  font-size: 18px;
  letter-spacing: 0.12px;
}
.item-user .desc {
  font-family: PingFangSC-Medium;
  color: #302e3c;
  font-size: 14px;
  opacity: 0.5;
  letter-spacing: 0.09px;
}
.item-user * {
  vertical-align: middle;
}
.item-user .item-right {
  display: inline-block;
  margin-left: 5px;
}
.item-user .choose-tag {
  border: 0px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -20px;
  width: 40px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/login_dialog.vue